// Pantallas del menú - Exportación agrupada para compatibilidad con Fast Refresh
export const SCREEN_IDS = {
  MAP: 2,
  REPORTS: 3,
  TRACKING_UNITS: 4,
  GEOFENCES_CATALOG: 5,
  ASSIGNED_GEOFENCES: 6,
  LOCATIONS_CATALOG: 7,
  IMPORT_LOCATIONS: 8,
  BACKLOG_JOBS: 9,
  JOBS_BOARD: 10,
  JOBS_REPORT: 11,
  JOBS_WORK_ACTIVITY: 12,
  SAFE_DRIVER: 13,
  LOGISTIC_ROUTE_CATALOG: 14,
  LOGISTIC_ROUTE_MONITOR: 15,
  LOGISTIC_ROUTE_REPORT: 16,
  ASSIGN_LOGISTIC_ROUTE: 17,
  WORK_PLAN_CATALOG: 18,
  WORK_PLAN_MONITOR: 19,
  WORK_PLAN_REPORT: 20,
  ASSIGN_WORK_PLAN: 21,
  TEMPERATURE_TELEMETRY: 22,
  FUEL_TELEMETRY_MONITOR: 23,
  PREVENTIVE_NOTICES: 24,
  SPAREPARTS_CATALOG: 25,
  WORKMANSHIPS_CATALOG: 26,
  SPAREPARTS_CATEGORIES_CATALOG: 27,
  SPAREPARTS_PROVIDERS_CATALOG: 28,
  GENERAL_MAINTENANCE_REPORT: 29,
  BY_CATEGORY_REPORT: 30,
  BY_UNIT_REPORT: 31,
  BY_WORKSHOP_REPORT: 32,
  IMPORT_MAINTENANCE_TICKETS: 33,
  NEW_TICKET: 34,
  IMPORT_FUEL_TICKETS: 35,
  FUEL_TICKETS_CONSOLIDATED_REPORT: 36,
  FUEL_TICKETS_REPORT_BY_UNIT: 37,
  OPERATOR: 38,
  ORGANIZATION: 39,
  DIVISION: 40,
  SUBDIVISION: 41,
  SERVICE_CLASSES: 42,
  AGENT: 43,
  GROUPS: 44,
  SHIFT: 45,
  TRIGGER: 46,
  USERS: 47,
  DRIVERS: 48,
  PEOPLE: 49,
  FORMS_CATALOG: 50,
  ANSWERS_FORMS: 51,
  DEVICES: 52,
  SIMS: 53,
  SENSORS: 54,
  ASSETS: 55,
  VEHICLES: 56,
  EMAIL_NOTIFICATIONS: 57,
  CONSOLE_NOTIFICATIONS: 58,
  WEB_SERVICE_NOTIFICATIONS: 59,
  IMPORT_JOBS: 60,
  SCHEDULED_WORKPLANS: 61,
  FUEL_TELEMETRY_REPORT: 62,
  CONTRACTS: 63,
  FLEET: 64,
  CUSTOMERS: 65,
  CONTACTS: 66,
  MAINTENANCE_RANGES: 67,
  CONTRACT_TEMPLATES: 68,
  QUOTATIONS: 69,
  OPTIMIZATIONS: 70,
  IMPORT_ROUTE_ASSIGNMENTS: 72,
  RECORD_MULTIPLE_TICKETS: 73,
  BUSINESS_PARTNERS: 74,
  WEB_SERVICE_RATES: 75,
  WORKPLAN_IMPORT: 76,
  TELEMETRY_UNITS: 77,
  WORKSHOP_ADD_ORDER: 78,
  AUTOMATIZATIONS: 79,
  TELEMETRY_OBD2: 80,
  FUEL_TELEMETRY_REPORT_BY_VEHICLES: 81,
  PROTOCOL_CATALOG: 82,
  SYSTEM_NOTIFICATIONS: 83,
  // 84 reservado (era LOGISTIC_ROUTE_ETA_MONITOR — Monitor ETA legacy
  // removido en WT-1062; el screenId no se reutiliza para no chocar con
  // permisos antiguos en BD).
  TELEMETRY_FUEL_LOADS_REPORT: 85,
  FUEL_TICKETS_REPORT: 86,
  FUEL_TELEMETRY_REPORT_BY_VEHICLES_WEEKLY: 87,
  VIDEO_DASHBOARD: 88,
  VIDEO_EVENTS_HISTORY: 89,
  VIDEO_HISTORY: 90,
  JOBS_MONITOR: 91,
  TRACKER_NOTIFICATIONS: 92,
  MONITORING_CENTER_CONSOLE_REPORT: 93,
  LOGISTIC_ROUTE_STATE_REPORT: 94,
  WHATSAPP: 95,
  BULK_USER_MANAGEMENT: 96,
  BULK_INSERTS: 97,
  LOGISTIC_ROUTE_SECURITY: 98,
  LOGISTIC_ROUTE_SECURITY_HISTORY: 99,
  ORDERS_POOL: 100,
  ORDERS_INTEGRATIONS: 101,
  API_CONSUMPTION: 102,
  PUBLIC_REFERENCES_MAP: 103,
  TEAM_ACTIONS: 104
} as const;

// Exportaciones individuales para compatibilidad hacia atrás
export const MAP = SCREEN_IDS.MAP;
export const REPORTS = SCREEN_IDS.REPORTS;
export const TRACKING_UNITS = SCREEN_IDS.TRACKING_UNITS;
export const GEOFENCES_CATALOG = SCREEN_IDS.GEOFENCES_CATALOG;
export const ASSIGNED_GEOFENCES = SCREEN_IDS.ASSIGNED_GEOFENCES;
export const LOCATIONS_CATALOG = SCREEN_IDS.LOCATIONS_CATALOG;
export const IMPORT_LOCATIONS = SCREEN_IDS.IMPORT_LOCATIONS;
export const BACKLOG_JOBS = SCREEN_IDS.BACKLOG_JOBS;
export const JOBS_BOARD = SCREEN_IDS.JOBS_BOARD;
export const JOBS_MONITOR = SCREEN_IDS.JOBS_MONITOR;
export const JOBS_REPORT = SCREEN_IDS.JOBS_REPORT;
export const JOBS_WORK_ACTIVITY = SCREEN_IDS.JOBS_WORK_ACTIVITY;
export const SAFE_DRIVER = SCREEN_IDS.SAFE_DRIVER;
export const LOGISTIC_ROUTE_CATALOG = SCREEN_IDS.LOGISTIC_ROUTE_CATALOG;
export const LOGISTIC_ROUTE_MONITOR = SCREEN_IDS.LOGISTIC_ROUTE_MONITOR;
export const LOGISTIC_ROUTE_REPORT = SCREEN_IDS.LOGISTIC_ROUTE_REPORT;
export const ASSIGN_LOGISTIC_ROUTE = SCREEN_IDS.ASSIGN_LOGISTIC_ROUTE;
export const WORK_PLAN_CATALOG = SCREEN_IDS.WORK_PLAN_CATALOG;
export const WORK_PLAN_MONITOR = SCREEN_IDS.WORK_PLAN_MONITOR;
export const WORK_PLAN_REPORT = SCREEN_IDS.WORK_PLAN_REPORT;
export const ASSIGN_WORK_PLAN = SCREEN_IDS.ASSIGN_WORK_PLAN;
export const TEMPERATURE_TELEMETRY = SCREEN_IDS.TEMPERATURE_TELEMETRY;
export const FUEL_TELEMETRY_MONITOR = SCREEN_IDS.FUEL_TELEMETRY_MONITOR;
export const PREVENTIVE_NOTICES = SCREEN_IDS.PREVENTIVE_NOTICES;
export const SPAREPARTS_CATALOG = SCREEN_IDS.SPAREPARTS_CATALOG;
export const WORKMANSHIPS_CATALOG = SCREEN_IDS.WORKMANSHIPS_CATALOG;
export const SPAREPARTS_CATEGORIES_CATALOG = SCREEN_IDS.SPAREPARTS_CATEGORIES_CATALOG;
export const SPAREPARTS_PROVIDERS_CATALOG = SCREEN_IDS.SPAREPARTS_PROVIDERS_CATALOG;
export const GENERAL_MAINTENANCE_REPORT = SCREEN_IDS.GENERAL_MAINTENANCE_REPORT;
export const BY_CATEGORY_REPORT = SCREEN_IDS.BY_CATEGORY_REPORT;
export const BY_UNIT_REPORT = SCREEN_IDS.BY_UNIT_REPORT;
export const BY_WORKSHOP_REPORT = SCREEN_IDS.BY_WORKSHOP_REPORT;
export const IMPORT_MAINTENANCE_TICKETS = SCREEN_IDS.IMPORT_MAINTENANCE_TICKETS;
export const NEW_TICKET = SCREEN_IDS.NEW_TICKET;
export const IMPORT_FUEL_TICKETS = SCREEN_IDS.IMPORT_FUEL_TICKETS;
export const FUEL_TICKETS_CONSOLIDATED_REPORT = SCREEN_IDS.FUEL_TICKETS_CONSOLIDATED_REPORT;
export const FUEL_TICKETS_REPORT_BY_UNIT = SCREEN_IDS.FUEL_TICKETS_REPORT_BY_UNIT;
export const OPERATOR = SCREEN_IDS.OPERATOR;
export const ORGANIZATION = SCREEN_IDS.ORGANIZATION;
export const DIVISION = SCREEN_IDS.DIVISION;
export const SUBDIVISION = SCREEN_IDS.SUBDIVISION;
export const SERVICE_CLASSES = SCREEN_IDS.SERVICE_CLASSES;
export const AGENT = SCREEN_IDS.AGENT;
export const GROUPS = SCREEN_IDS.GROUPS;
export const SHIFT = SCREEN_IDS.SHIFT;
export const TRIGGER = SCREEN_IDS.TRIGGER;
export const USERS = SCREEN_IDS.USERS;
export const DRIVERS = SCREEN_IDS.DRIVERS;
export const PEOPLE = SCREEN_IDS.PEOPLE;
export const FORMS_CATALOG = SCREEN_IDS.FORMS_CATALOG;
export const ANSWERS_FORMS = SCREEN_IDS.ANSWERS_FORMS;
export const DEVICES = SCREEN_IDS.DEVICES;
export const SIMS = SCREEN_IDS.SIMS;
export const SENSORS = SCREEN_IDS.SENSORS;
export const ASSETS = SCREEN_IDS.ASSETS;
export const VEHICLES = SCREEN_IDS.VEHICLES;
export const EMAIL_NOTIFICATIONS = SCREEN_IDS.EMAIL_NOTIFICATIONS;
export const CONSOLE_NOTIFICATIONS = SCREEN_IDS.CONSOLE_NOTIFICATIONS;
export const WEB_SERVICE_NOTIFICATIONS = SCREEN_IDS.WEB_SERVICE_NOTIFICATIONS;
export const TRACKER_NOTIFICATIONS = SCREEN_IDS.TRACKER_NOTIFICATIONS;
export const IMPORT_JOBS = SCREEN_IDS.IMPORT_JOBS;
export const SCHEDULED_WORKPLANS = SCREEN_IDS.SCHEDULED_WORKPLANS;
export const FUEL_TELEMETRY_REPORT = SCREEN_IDS.FUEL_TELEMETRY_REPORT;
export const CONTRACTS = SCREEN_IDS.CONTRACTS;
export const FLEET = SCREEN_IDS.FLEET;
export const CUSTOMERS = SCREEN_IDS.CUSTOMERS;
export const CONTACTS = SCREEN_IDS.CONTACTS;
export const MAINTENANCE_RANGES = SCREEN_IDS.MAINTENANCE_RANGES;
export const CONTRACT_TEMPLATES = SCREEN_IDS.CONTRACT_TEMPLATES;
export const QUOTATIONS = SCREEN_IDS.QUOTATIONS;
export const OPTIMIZATIONS = SCREEN_IDS.OPTIMIZATIONS;
export const IMPORT_ROUTE_ASSIGNMENTS = SCREEN_IDS.IMPORT_ROUTE_ASSIGNMENTS;
export const RECORD_MULTIPLE_TICKETS = SCREEN_IDS.RECORD_MULTIPLE_TICKETS;
export const BUSINESS_PARTNERS = SCREEN_IDS.BUSINESS_PARTNERS;
export const WEB_SERVICE_RATES = SCREEN_IDS.WEB_SERVICE_RATES;
export const WORKPLAN_IMPORT = SCREEN_IDS.WORKPLAN_IMPORT;
export const TELEMETRY_UNITS = SCREEN_IDS.TELEMETRY_UNITS;
export const WORKSHOP_ADD_ORDER = SCREEN_IDS.WORKSHOP_ADD_ORDER;
export const AUTOMATIZATIONS = SCREEN_IDS.AUTOMATIZATIONS;
export const TELEMETRY_OBD2 = SCREEN_IDS.TELEMETRY_OBD2;
export const FUEL_TELEMETRY_REPORT_BY_VEHICLES = SCREEN_IDS.FUEL_TELEMETRY_REPORT_BY_VEHICLES;
export const PROTOCOL_CATALOG = SCREEN_IDS.PROTOCOL_CATALOG;
export const MONITORING_CENTER_CONSOLE_REPORT = SCREEN_IDS.MONITORING_CENTER_CONSOLE_REPORT;
export const SYSTEM_NOTIFICATIONS = SCREEN_IDS.SYSTEM_NOTIFICATIONS;
export const TELEMETRY_FUEL_LOADS_REPORT = SCREEN_IDS.TELEMETRY_FUEL_LOADS_REPORT;
export const FUEL_TICKETS_REPORT = SCREEN_IDS.FUEL_TICKETS_REPORT;
export const FUEL_TELEMETRY_REPORT_BY_VEHICLES_WEEKLY =
  SCREEN_IDS.FUEL_TELEMETRY_REPORT_BY_VEHICLES_WEEKLY;
export const VIDEO_DASHBOARD = SCREEN_IDS.VIDEO_DASHBOARD;
export const VIDEO_EVENTS_HISTORY = SCREEN_IDS.VIDEO_EVENTS_HISTORY;
export const VIDEO_HISTORY = SCREEN_IDS.VIDEO_HISTORY;
export const BULK_USER_MANAGEMENT = SCREEN_IDS.BULK_USER_MANAGEMENT;
export const LOGISTIC_ROUTE_STATE_REPORT = SCREEN_IDS.LOGISTIC_ROUTE_STATE_REPORT;
export const LOGISTIC_ROUTE_SECURITY = SCREEN_IDS.LOGISTIC_ROUTE_SECURITY;
export const WHATSAPP = SCREEN_IDS.WHATSAPP;
export const BULK_INSERTS = SCREEN_IDS.BULK_INSERTS;
export const ORDERS_POOL = SCREEN_IDS.ORDERS_POOL;
export const ORDERS_INTEGRATIONS = SCREEN_IDS.ORDERS_INTEGRATIONS;
export const LOGISTIC_ROUTE_SECURITY_HISTORY = SCREEN_IDS.LOGISTIC_ROUTE_SECURITY_HISTORY;
export const API_CONSUMPTION = SCREEN_IDS.API_CONSUMPTION;
export const PUBLIC_REFERENCES_MAP = SCREEN_IDS.PUBLIC_REFERENCES_MAP;
export const TEAM_ACTIONS = SCREEN_IDS.TEAM_ACTIONS;
